<template>
  <ChartContainer
    :value="current"
    :type="type"
    :lastChart="lastChart"
    :nextChart="nextChart">
    <div
      class="ry-dashboard__text-grid-control ql-container ql-snow ">
      <div
        class="ql-editor"
        v-html="current.showPropertiesHolder.text">
      </div>
    </div>
  </ChartContainer>
</template>

<script>
  import ChartContainer from './common/container'

  export default {
    props: {
      value: Object,
      type: Number,
      nextChart: Function,
      lastChart: Function
    },
    components: {
      ChartContainer
    },
    data() {
      return {
        current: this.value
      }
    },
  }
</script>

<style lang="less">
  .ry-dashboard__text-grid-control.ql-container.ql-snow {
    border: none;
  }
</style>

